// extracted by mini-css-extract-plugin
export default {"folder-icon":"styles_folder-icon__t+CNw"};